import { render, staticRenderFns } from "./PresentationsPage.vue?vue&type=template&id=4b418e30&scoped=true&"
import script from "./PresentationsPage.vue?vue&type=script&lang=js&"
export * from "./PresentationsPage.vue?vue&type=script&lang=js&"
import style0 from "./PresentationsPage.vue?vue&type=style&index=0&id=4b418e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b418e30",
  null
  
)

export default component.exports